import { Component, effect, inject } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { LoadingComponent } from "@shared/src/lib/components/loading/loading.component";
import { SelectContactSearchComponent } from "@shared/src/lib/components/select-contact-search/select-contact-search.component";
import { FileData, UploadComponent } from "@shared/src/lib/components/upload/upload.component";
import { CentsToDollarsPipe, Contact, NavigationService, PhotoRepository,
	SecureDocumentUploadDto,
	SuccessfulDocumentUpload,
	UserStore} from "@shared/src/public-api";
import { Subject } from "rxjs";

@Component({
	selector: "jhmc-secure-documents-upload",
	imports: [
		MatFormFieldModule,
		MatInputModule,
		FormsModule,
		MatAutocompleteModule,
		UploadComponent,
		ReactiveFormsModule,
		SelectContactSearchComponent,
		LoadingComponent,
		CentsToDollarsPipe
	],
	templateUrl: "./secure-documents-upload.component.html",
	styleUrl: "./secure-documents-upload.component.scss"
})
export class SecureDocumentsUploadComponent {
	public selectedPage: string = "SECURE_DOCUMENTS_UPLOAD";
	public searchQuery: string = "";
	public searchQueryUpdate: Subject<Event> = new Subject<Event>();
	public showFilesModal: boolean = false;
	public selectedContact: Contact;
	public formData: FormData;
	public filename: string;
	public loading: boolean = false;
	public isPublicDefender: boolean = false;
	readonly userStore = inject(UserStore);
	public costOfDocument: number = 0;
	public pageCount: number = 0;
	public isPdf: boolean = false;

	public constructor(private navigationService: NavigationService, private photoRepository: PhotoRepository) {
		this.navigationService = navigationService;

		effect(() => {
			this.isPublicDefender = this.userStore.isPublicDefender();
		})
	}

	public goToPreviousPage()
	{
		this.navigationService.goToPreviousPage("/");
	}

	public selectDocument() {
		this.showFilesModal = true;
	}

	public reset() {
		this.filename = "";
		this.formData = null;
		this.selectedContact = null;
		this.pageCount = 0;
		this.costOfDocument = 0;
	}

	public sendDocuments() {
		this.loading = true;
		const uploadDto: SecureDocumentUploadDto = {
			type: this.isPdf ? "DOCUMENT" : "IMAGE",
			pageCount: this.pageCount,
			isPublicDefender: this.isPublicDefender
		};
		this.formData.append("secureDocumentUploadDto", new Blob([JSON
			.stringify(uploadDto)], {
			type: "application/json"
		}));
		this.photoRepository.uploadDocuments(this.formData, `documents/inmates/${this.selectedContact.contactId}`)
			.subscribe((_document: SuccessfulDocumentUpload) => {
				this.loading = false;
				this.reset();
				this.userStore.fetchUser();
			});
	}

	public clearContact()
	{
		this.selectedContact = null;
	}

	public selectContact(contact: Contact): void
	{
		this.selectedContact = contact;
	}

	public setFileData(fileData: FileData) {
		this.formData = fileData.formData;
		this.filename = fileData.name;
		this.showFilesModal = false;
		this.pageCount = fileData.pageCount;
		this.costOfDocument = 8 * this.pageCount;
		this.isPdf = fileData.isPdf;
	}
}
